import axiosInstance from '@/utils/api.js'

var state = {
  vodServiceLink: []
}

var getters = {
  VOD_SERVICE_LINK: (state) => {
    return state.vodServiceLink
  }
}

var mutations = {
  SET_VOD_SERVICE_LINK: (state, payload) => {
    state.vodServiceLink = payload || []
  }
}

var actions = {
  GET_VOD_SERVICE_LINK: async (context, payload) => {
    let result = await axiosInstance.get('/users/servicelinks/periodic_slink_stats?slink_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_VOD_SERVICE_LINK', result.data)
    }
  },
  CREATE_VOD_SERVICE_LINK: (context, payload) => {
    return axiosInstance.post('/users/servicelinks/vod', payload)
  },
  UPDATE_VOD_SERVICE_LINK: (context, payload) => {
    return axiosInstance.put('/users/servicelinks/vod', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/servicesLinkVOD.js